import React, { useState, useCallback } from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';

import { PRODUCT_FEATURES } from '@dragonfruit/constants/premiumPage';

import CollapseItem from './components/CollapseItem';

import styles from './ProductFeatures.scss';

import homeIcon from '../../images/ic_home_active_24.svg';
import qzcontIcon from '../../images/ic_qzcont_active_24.svg';
import sessionIcon from '../../images/ic_session_active_24.svg';
import classroomIcon from '../../images/ic_classroom_active_24.svg';
const icons = [homeIcon, sessionIcon, qzcontIcon, classroomIcon];

const ProductFeatures = ({ t }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const features = t('premium.product.features', {
    returnObjects: true,
    defaultValue: [],
  }).filter(f => f.title !== '-');

  const clickChange = useCallback(
    index => () => {
      setSelectedIndex(index);
    },
    []
  );

  return (
    <section className={styles.root} id={PRODUCT_FEATURES}>
      <h3>{t('premium.product.title')}</h3>
      <p className={styles.descr}>{t('premium.product.descr')}</p>
      <div className={styles.features}>
        <img src={features[selectedIndex].imageUrl} className={styles.image} />
        <div className={styles.collapseBlock}>
          {features.map(({ title, descr }, index) => (
            <CollapseItem
              icon={icons[index]}
              title={title}
              descr={descr}
              isSelected={selectedIndex === index}
              onClick={clickChange(index)}
              key={title}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

ProductFeatures.propTypes = {
  t: func.isRequired,
};

export default translate(['premium'])(ProductFeatures);



// WEBPACK FOOTER //
// ./app/containers/Premium/components/ProductFeatures/ProductFeatures.jsx